module.exports = __webpack_public_path__ + "static/media/expii_Photo_Edit_v3.d55e470d.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/homepage/expii_Photo_Edit_v3.png
// module id = 909
// module chunks = 21